import React from 'react';
import { useParams } from 'react-router-dom';

import TitleLayout from '@/components/Layout/TitleLayout';
import TabbedContainer from '@/components/TabbedContainer';
import { useConferenceManagement } from '@/hooks/featureFlags/active-flags/useConferenceManagement';
import OrgRolesForm from '../components/OrgRolesForm';
import { UserConferences } from '../components/UserConferences';
import UserProfileForm from '../components/UserProfileForm';
import UserSettingsForm from '../components/UserSettingsForm';

export const ManageUserPage = () => {
  const params = useParams();
  const { userId } = params;
  const conferenceMangementFlag = useConferenceManagement();

  const tabs = [
    { name: 'Profile', href: '#', content: <UserProfileForm userId={userId} /> },
    { name: 'Settings', href: '#', content: <UserSettingsForm userId={userId} /> },
    { name: 'Org Roles', href: '#', content: <OrgRolesForm userId={userId} /> },
  ];

  return (
    <TitleLayout title="Edit User">
      <div className="flex flex-col gap-6">
        <div className="border-b border-gray-200">
          <TabbedContainer tabs={tabs} />
        </div>
        {userId && conferenceMangementFlag && <UserConferences userId={userId} />}
      </div>
    </TitleLayout>
  );
};
